var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.58,
    height: 12.445,
    viewBox: "0 0 7.58 12.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0.871 0.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M5.351.486.486,5.351",
    fill: "none",
    stroke: "#9a3f82",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5_Copy",
    "data-name": "Line 5 Copy",
    d: "M5.351-.486.486-5.351",
    transform: "translate(0 10.703)",
    fill: "none",
    stroke: "#9a3f82",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.92
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft2);
export default __webpack_public_path__ + "static/media/arrowLeft2.84ea3a3ebd940ffae1b8dd086d1183b0.svg";
export { ForwardRef as ReactComponent };